<template>
  <div class="login-page">
    <img class="logo" alt :src="images.logo" />
    <div class="bg"></div>
    <div class="login-panel">
      <p class="info">Please login your google account</p>
      <div @click="checkLogin" tabindex="-1" class="login-btn text-center">
        <img :src="images.gLogo" alt />
        <span class="b">Continue With Google</span>
      </div>
    </div>
    <img class="flight" alt :src="images.loginFlight" />
  </div>
</template>
<script>
import config from "../core/config";
import images from "../core/images";
import { mapActions } from "vuex";

export default {
  created() {
    this.initGapi();
  },
  data() {
    return {
      gu: {},
      gApiLoaded: false
    };
  },
  methods: {
    initGapi() {
      if (!window.gapi) {
        setTimeout(this.initGapi, 200);
        return;
      }
      new Promise((rs, rj) => {
        if (!window.gapi.auth2) {
          window.gapi.load("auth2", () => {
            window.gapi.auth2
              .init({
                hosted_domain: "tigerairtw.com",
                client_id: config.GOOGLE_CLIENT_ID
                // scope: "email profile openid",
                // response_type: "id_token permission"
              })
              .then(() => rs(window.gapi.auth2))
              .catch(ex => rj(ex));
          });
        } else {
          rs(window.gapi.auth2);
        }
      }).then(() => (this.gApiLoaded = true));
    },
    checkLogin() {
      if (this.gApiLoaded) {
        this.login(window.gapi.auth2);
      } else {
        //this.forceLogin();
      }
    },
    ...mapActions(["login","forceLogin"])
  },
  computed: {
    images: () => images
  }
};
</script>
<style lang="scss" scoped>
.login-page {
  overflow-x: hidden;
  .logo {
    top: 10%;
    left: 50%;
    width: 50%;
    position: fixed;
    max-width: 30rem;
    transform: translateX(-50%);
    @media (max-height: 620px) {
      width: 70%;
      top: 1.5rem;
    }
    @media (max-width: 768px) {
      width: 65%;
    }
    @media (max-width: 512px) {
      width: 75%;
    }
  }
  .flight {
    position: absolute;
    position: fixed;
    left: 50%;
    top: 27%;
    z-index: 1;
    width: 36%;
    max-width: 30rem;
    min-width: 20rem;
    transform: translateX(-15%);
    @media (max-height: 768px) {
      top: 24%;
      width: 30%;
    }
    @media (max-width: 1280px) {
      top: 30%;
    }
    @media (max-width: 768px) {
      width: 50%;
      transform: translateX(-20%);
    }
    @media (max-width: 512px) {
      width: 70%;
      transform: translateX(-35%);
    }
  }

  .bg {
    left: 0;
    bottom: 0;
    width: 100vw;
    width: 100%;
    height: 40%;
    z-index: -1;
    position: absolute;
    background: url("../assets/imgs/login-bg.svg");
  }
  .login-panel {
    left: 50%;
    top: 50%;
    width: 40%;
    padding: 2rem;
    min-width: 20rem;
    font-size: 1rem;
    position: absolute;
    background-color: white;
    transform: translateX(-50%);
    box-shadow: $common-shadow;
    border: 1px solid $gray;
    border-radius: $border-radius;
    .info {
      font-size: 1.25rem;
    }
    .login-btn {
      outline: none;
      line-height: 3.6;
      cursor: pointer;
      border-radius: $border-radius;
      border: solid 1px $light-black;
      img {
        width: 2rem;
        margin-right: 1rem;
      }
    }
  }
}
</style>